import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from '../utils/types';
import css from './DesktopQuestionCell.css';
import { Table } from 'semantic-ui-react';
import NoteIcon from './NoteIcon';
import { hasComment } from 'utils/surveys';

export default class DesktopQuestionCell extends React.Component {

  get noteIcon() {
    const { isChecked, questionId, answers } = this.props;
    return hasComment(questionId, answers) && isChecked(questionId) ? <NoteIcon  isMobile={false} /> : null;
  }

  render() {
    return (
      <Table.Cell>
        <div className={css['checkbox-container']}>
          <div data-role="progressSurveyCheckbox">
            {this.props.renderCheckbox(this.props.questionId, this.props.questionName)}
            {this.noteIcon}
          </div>
          {this.props.plusButton}
        </div>
      </Table.Cell>
    );
  }
}

DesktopQuestionCell.propTypes = {
  questionName: PropTypes.string.isRequired,
  questionId: SFEntityID.isRequired,
  isChecked: PropTypes.func.isRequired,
  renderCheckbox: PropTypes.func.isRequired,
  answers: PropTypes.array,
  plusButton: PropTypes.object
};
